export class ClearAwaitingDeviceToken {
    public static readonly type = '[RootState] Clear awaiting device token';
}
